import React, { useRef } from 'react';
import { expandFontTheme, IconConfirmation, theme, useLocalizationContext, } from '@contrast-security-inc/design-system-foundations';
import { TextOverflow } from '@contrast-security-inc/design-system-popovers';
import { Text } from '@contrast-security-inc/design-system-typography';
import { HighlightedText } from './HighlightedText';
import { css, cx } from '@emotion/css';
import * as messages from './translations';
const textItemWrapperStyles = css `
  flex: 1;
  overflow: hidden;
  position: relative;
  text-overflow: ellipsis;
`;
const textItemElementStyles = css `
  white-space: nowrap;
`;
const textItemAllowWrappingStyles = css `
  -webkit-box-orient: vertical;
  /* stylelint-disable-next-line value-no-vendor-prefix */
  display: -webkit-box;
  line-clamp: 6;
  -webkit-line-clamp: 6;
  text-overflow: ellipsis;
  white-space: normal;
`;
const textItemSelectedStyles = css `
  ${expandFontTheme(theme.font.bodyItalic)};
`;
export const ListboxItemText = ({ AllowCreateProps, allowItemTextWrap = false, inputValue, isAnchoredItem, isSelected = false, item, itemIndex, itemToString, testId, }) => {
    const { formatMessage } = useLocalizationContext();
    const textItemWrapperElement = useRef(null);
    const textItemInnerElement = useRef(null);
    const itemValueAsString = itemToString(item ?? '');
    const showCreatable = AllowCreateProps?.allowCreate && item?.isCreateable;
    const itemText = showCreatable && !isAnchoredItem ? (React.createElement(React.Fragment, null,
        inputValue,
        ' ',
        React.createElement(Text, { font: "metadata", color: "neutral80", testId: "" }, AllowCreateProps.label ?? formatMessage(messages, 'create')))) : (React.createElement(HighlightedText, { itemValue: itemValueAsString, inputText: inputValue, testId: testId }));
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { className: textItemWrapperStyles, ref: textItemWrapperElement, "data-testid": `${testId}-listbox-item-text-${itemIndex}` },
            React.createElement("span", { className: cx(textItemElementStyles, isSelected && textItemSelectedStyles, allowItemTextWrap && textItemAllowWrappingStyles), ref: textItemInnerElement },
                React.createElement(TextOverflow, { font: isSelected ? 'bodyItalic' : 'body', offset: [-6, 8], testId: `${testId}-listbox-item-text-textoverflow-${itemIndex}` }, inputValue === '' || isSelected ? itemValueAsString : itemText))),
        isSelected && React.createElement(IconConfirmation, { size: "sm", color: "black" })));
};
